var React = require('react');

function RadioSelected (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"radio_button","data-name":"radio button","transform":"translate(-950 -456)"},[React.createElement("g",{"id":"border","transform":"translate(950 456)","fill":"#fff","stroke":"#bdc1c6","strokeWidth":"1","key":0},[React.createElement("circle",{"cx":"8","cy":"8","r":"8","stroke":"none","key":0}),React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"none","key":1})]),React.createElement("circle",{"id":"fill","cx":"5","cy":"5","r":"5","transform":"translate(953 459)","fill":"#254c5b","key":1})]));
}

RadioSelected.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = RadioSelected;

RadioSelected.default = RadioSelected;
